/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var PlayArrowOutlineIcon = function PlayArrowOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5.72317C5 4.18753 6.65896 3.22479 7.99228 3.98668L18.9767 10.2635C20.3203 11.0313 20.3203 12.9687 18.9767 13.7365L7.99228 20.0133C6.65896 20.7752 5 19.8125 5 18.2768V5.72317ZM17.9844 12L7 5.72317V18.2768L17.9844 12Z"
  }));
};
export default PlayArrowOutlineIcon;